import React from "react";
import { Route, Switch } from "react-router-dom";
import { BulletinList } from "./views/bulletin-list";
import { BulletinDetail } from "./views/bulletin-detail/bulletin-detail";
import { VueContextType } from "@iloq/shared-react/vueContext";
import { useGetPartnerBulletinsQuery } from "./query-hooks/use-get-bulletins";
import { Spinner, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { PrivateRoute } from "@iloq/shared-react/PrivateRoute";

export function Bulletins({ vueProps }: { vueProps: VueContextType }): React.ReactNode {
  const countryCode = vueProps.$store.getters["user"]["countryCode"] as string;
  const bulletinsQuery = useGetPartnerBulletinsQuery(countryCode);

  if (bulletinsQuery.isLoading) {
    return <Spinner data-testid="bulletins-spinner" mt="4xl" mx="auto" display="block" />;
  }

  if (bulletinsQuery.isError) {
    return (
      <Text mt="4xl">
        <FormattedMessage id="dialog.generalError.body" />
      </Text>
    );
  }

  if (!bulletinsQuery.data?.length) {
    return (
      <Text mt="4xl">
        <FormattedMessage id="bulletin.category.empty" />
      </Text>
    );
  }

  return (
    <Switch>
      <PrivateRoute exact path="/bulletin">
        <BulletinList bulletinList={bulletinsQuery.data} locale={vueProps.locale} />
      </PrivateRoute>

      <PrivateRoute path="/bulletin/:id">
        {({ match }: { match: { params: { id: string } } }) => (
          <BulletinDetail
            bulletin={bulletinsQuery.data?.find(
              (bulletin) => bulletin.id === Number(match.params.id),
            )}
          />
        )}
      </PrivateRoute>
    </Switch>
  );
}
